import { Script } from 'gatsby';
import React, { useEffect, useState } from 'react';

import * as styles from './goldcast-video-embed.module.css';

export const GoldcastVideoEmbed = ({ videoId }: { videoId: string }) => {
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Add a global event listener for the iframe load
		const handleIframeLoad = () => {
			setIsLoading(false);
		};

		// Wait for the script to load and then find the iframe
		const checkForIframe = () => {
			const iframe = document.querySelector(`#player-${videoId} iframe`);
			if (iframe) {
				iframe.addEventListener('load', handleIframeLoad);
				return true;
			}
			return false;
		};

		// Try to find the iframe immediately and then periodically
		if (!checkForIframe()) {
			const interval = setInterval(() => {
				if (checkForIframe()) {
					clearInterval(interval);
				}
			}, 100);

			// Cleanup interval after 10 seconds
			setTimeout(() => clearInterval(interval), 10000);
		}

		return () => {
			const iframe = document.querySelector(`#player-${videoId} iframe`);
			if (iframe) {
				iframe.removeEventListener('load', handleIframeLoad);
			}
		};
	}, [videoId]);

	return (
		<div className={styles.container}>
			<div id={`player-${videoId}`} className={styles.videoPlayer} />
			{isLoading && (
				<div className={styles.loadingContainer}>
					<p>
						Your webinar recording will load shortly. If it takes
						more than 10 seconds, you can{' '}
						<a
							target='blank'
							href={`https://newregbuilder.goldcast.io/on-demand/${videoId}`}
						>
							watch the webinar on Goldcast
						</a>
						.
					</p>
				</div>
			)}
			<Script
				src={`https://ondemand.registration.goldcast.io/embedscript/${videoId}`}
			/>
		</div>
	);
};
